module.exports = __webpack_public_path__ + "media/assets/images/zidosyai_ranking_first_view-8296de785712725b40a593ecc293e3d5.png";